module.exports = __webpack_public_path__ + "img/feature1.f97be63a.svg";